document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bfcm2026-circuit').forEach(function (root) {
    var glow = root.querySelector('filter');
    if (glow && glow.id) root.style.setProperty('--cm-glow', 'url(#' + glow.id + ')');
      /*
      PLAY NOW 打开 circuit-master.html 里的游戏，规则没有改：
      1. 三关。教程关空格固定转法；后面两关按既定通路打乱，并保证开局没接通。
      2. 每点一次水管顺时针 90°，消耗 1 次点击。点击用完还没接通就算失败。
      3. 电源从左侧进来，只有两边都开口才通电；青色是通电，琥珀色是整条电路接通、空调开始降温。
      4. 提示在第 2、3 关每次扣 20 分。剩下的点击每个 +15 分。
      5. 结算给出优惠码，并画出 1080×1350 的分数卡供下载。Esc 或右上角关闭回到页面。
    */
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var playBtn = root.querySelector('[data-play]');
    var game = root.querySelector('[data-game]');
    var closeBtn = root.querySelector('[data-close-game]');
    var stage = root.querySelector('[data-stage]');
    if (!playBtn || !game) return;

    var booted = false;
    var lastFocus = null;

    function closeGame() {
      game.hidden = true;
      document.body.classList.remove('bfcm2026-circuit-lock');
      if (stage) stage.inert = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function openGame() {
      lastFocus = document.activeElement;
      game.hidden = false;
      document.body.classList.add('bfcm2026-circuit-lock');
      if (stage) stage.inert = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!booted) {
            booted = true;
            boot();
          } else if (game._setSize) {
            game._setSize();
          }
        });
      });
    }

    function boot() {
      'use strict';
  const N = 1, E = 2, S = 4, W = 8, DIRS = [N, E, S, W];
  const DR = { [N]: -1, [E]: 0, [S]: 1, [W]: 0 };
  const DC = { [N]: 0, [E]: 1, [S]: 0, [W]: -1 };
  const OPP = { [N]: S, [E]: W, [S]: N, [W]: E };
  const ANG = { [N]: 0, [E]: 90, [S]: 180, [W]: 270 };
  const COUPONS = ['pro16^', 'pro17-', 'pro18='];
  const BONUS_PER_CLICK = 15;
  const START_TEMP = 90, END_TEMP = 64;

  const rot1 = m => ((m << 1) | (m >> 3)) & 15;
  const rotK = (m, k) => { for (let i = 0; i < k; i++) m = rot1(m); return m; };
  const fits = (m, t) => (m & t) === t;
  const minTurns = (m, t) => { for (let k = 0; k < 4; k++) if (fits(rotK(m, k), t)) return k; return 0; };
  const dirTo = (a, b) => { const dr = b[0] - a[0], dc = b[1] - a[1]; return dr === -1 ? N : dr === 1 ? S : dc === 1 ? E : W; };
  const rand = n => Math.floor(Math.random() * n);

  const LEVELS = [
    { name: 'Tutorial', rows: 3, cols: 4, src: 0, ac: 2,
      path: [[0,0],[0,1],[1,1],[2,1],[2,2],[2,3]],
      fixed: [0,1,1,1,0,1], decoys: 'empty', slack: 12, base: 100, hintCost: 0 },
    { name: 'Switchback', rows: 5, cols: 5, src: 2, ac: 0,
      path: [[2,0],[2,1],[1,1],[0,1],[0,2],[0,3],[1,3],[2,3],[2,4],[1,4],[0,4]],
      decoys: 'random', teeOnPath: 0.12, minClicks: 9, slack: 14, base: 200, hintCost: 20 },
    { name: 'Overload', rows: 6, cols: 6, src: 1, ac: 3,
      path: [[1,0],[1,1],[0,1],[0,2],[0,3],[1,3],[2,3],[2,2],[3,2],[4,2],[4,1],[5,1],[5,2],[5,3],[5,4],[4,4],[3,4],[3,5]],
      decoys: 'random', teeOnPath: 0.3, minClicks: 15, slack: 16, base: 300, hintCost: 20 }
  ];

  const $ = id => game.querySelector('[data-cm="' + id + '"]');
  const board = $('board');

  const G = { level: 0, layouts: [], tiles: [], clicks: 0, limit: 0, hints: 0, locked: false, busy: false,
              failed: false, scores: [], coupon: null, maxPowered: 0, hintTimer: null, cardCanvas: null, tempRaf: 0 };

  function flood(cfg, masks) {
    const seen = new Set();
    if (!(masks[cfg.src][0] & W)) return { seen, win: false };
    const q = [[cfg.src, 0]]; seen.add(cfg.src + ',0');
    while (q.length) {
      const [r, c] = q.shift(); const m = masks[r][c];
      for (const d of DIRS) {
        if (!(m & d)) continue;
        const nr = r + DR[d], nc = c + DC[d];
        if (nr < 0 || nc < 0 || nr >= cfg.rows || nc >= cfg.cols) continue;
        const key = nr + ',' + nc;
        if (seen.has(key)) continue;
        if (masks[nr][nc] & OPP[d]) { seen.add(key); q.push([nr, nc]); }
      }
    }
    const win = seen.has(cfg.ac + ',' + (cfg.cols - 1)) && !!(masks[cfg.ac][cfg.cols - 1] & E);
    return { seen, win };
  }

  function targetsFor(cfg) {
    const map = new Map();
    cfg.path.forEach((p, i) => {
      const inD = i === 0 ? W : dirTo(p, cfg.path[i - 1]);
      const outD = i === cfg.path.length - 1 ? E : dirTo(p, cfg.path[i + 1]);
      map.set(p[0] + ',' + p[1], { t: inD | outD, idx: i });
    });
    return map;
  }

  function cellsToMasks(cfg, cells) {
    const m = Array.from({ length: cfg.rows }, () => Array(cfg.cols).fill(0));
    cells.forEach(c => { m[c.r][c.c] = c.mask; });
    return m;
  }

  // Every level is built backwards from a known solution path, then scrambled, so it is always solvable.
  function generateLayout(cfg) {
    const targets = targetsFor(cfg);
    let best = null;
    for (let attempt = 0; attempt < 500; attempt++) {
      const cells = []; let min = 0;
      for (let r = 0; r < cfg.rows; r++) for (let c = 0; c < cfg.cols; c++) {
        const tg = targets.get(r + ',' + c);
        if (tg) {
          let base = tg.t, k;
          if (cfg.fixed) k = cfg.fixed[tg.idx];
          else {
            if (Math.random() < cfg.teeOnPath) { const extra = DIRS.filter(d => !(d & base)); base |= extra[rand(extra.length)]; }
            k = 1 + rand(3);
          }
          const mask = rotK(base, (4 - k) % 4);
          min += minTurns(mask, tg.t);
          cells.push({ r, c, mask, target: tg.t, pathIdx: tg.idx, empty: false });
        } else if (cfg.decoys === 'empty') {
          cells.push({ r, c, mask: 0, target: 0, pathIdx: -1, empty: true });
        } else {
          const shapes = [N|S, N|E, N|E, N|E|S, N|S];
          cells.push({ r, c, mask: rotK(shapes[rand(shapes.length)], rand(4)), target: 0, pathIdx: -1, empty: false });
        }
      }
      const layout = { cells, min, limit: min + cfg.slack };
      if (cfg.fixed) return layout;
      if (flood(cfg, cellsToMasks(cfg, cells)).win) continue;
      if (min >= cfg.minClicks) return layout;
      if (!best || min > best.min) best = layout;
    }
    return best;
  }

  function pipeSVG(mask) {
    let casing = '', wires = '';
    for (const d of DIRS) {
      if (!(mask & d)) continue;
      const a = ANG[d];
      casing += `<g transform="rotate(${a} 50 50)"><rect class="casing" x="36" y="0" width="28" height="50"/><rect class="flange" x="31" y="0" width="38" height="7" rx="1"/></g>`;
      wires += `<g transform="rotate(${a} 50 50)"><line class="wire" x1="50" y1="50" x2="50" y2="3"/><line class="spark" x1="50" y1="50" x2="50" y2="3"/></g>`;
    }
    return `<svg viewBox="0 0 100 100" aria-hidden="true">${casing}<circle class="hub" cx="50" cy="50" r="17"/>${wires}<circle class="hubw" cx="50" cy="50" r="8"/></svg>`;
  }

  const BOLT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" fill="currentColor"/></svg>';
  const FLAKE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 2v20M3.4 7l17.2 10M3.4 17 20.6 7"/></svg>';

  function startLevel(idx, regenerate) {
    const cfg = LEVELS[idx];
    G.level = idx;
    if (regenerate || !G.layouts[idx]) G.layouts[idx] = generateLayout(cfg);
    const layout = G.layouts[idx];
    G.limit = layout.limit; G.clicks = layout.limit; G.hints = 0;
    G.locked = false; G.busy = false; G.failed = false; G.maxPowered = 0;
    G.scores[idx] = undefined;
    clearHint();
    G.tiles = Array.from({ length: cfg.rows }, () => []);
    layout.cells.forEach(cell => { G.tiles[cell.r][cell.c] = { ...cell, deg: 0, el: null, svg: null }; });
    renderBoard();
    resetAC();
    updateAll();
    setCoach(introText(idx));
    $('hintCost').textContent = cfg.hintCost ? `(−${cfg.hintCost})` : '(free)';
    $('lvName').textContent = `Level ${idx + 1} · ${cfg.name}`;
  }

  function introText(idx) {
    if (idx === 0) return '<b>Tutorial:</b> Tap the pulsing tile to rotate it 90°. Link the red <b>TURBRO</b> power source on the left to the <b>AC</b> on the right.';
    if (idx === 1) return '<b>Level 2 · Switchback:</b> Longer route with decoy pipes. Plan your turns — every tap costs a click.';
    return '<b>Level 3 · Overload:</b> Expert grid with junction pipes and a longer route. Leftover clicks score big bonuses.';
  }

  function setCoach(html) { $('coach').innerHTML = html; }

  function setSize() {
    const cfg = LEVELS[G.level];
    const wrap = board.parentElement;
    const avail = wrap.clientWidth - 24;
    const gap = 4;
    let t = Math.floor((avail - gap * (cfg.cols + 1)) / (cfg.cols + 1.4));
    t = Math.max(36, Math.min(84, t));
    const term = Math.round(t * 0.7);
    board.style.gridTemplateColumns = `${term}px repeat(${cfg.cols}, ${t}px) ${term}px`;
    board.style.gridTemplateRows = `repeat(${cfg.rows}, ${t}px)`;
  }

  function renderBoard() {
    const cfg = LEVELS[G.level];
    board.innerHTML = '';
    board.classList.remove('complete');
    const src = document.createElement('div');
    src.className = 'term src'; src.style.gridRow = cfg.src + 1; src.style.gridColumn = 1;
    src.innerHTML = BOLT + '<span>PWR</span>';
    src.setAttribute('aria-label', 'TURBRO power source');
    board.appendChild(src);
    for (let r = 0; r < cfg.rows; r++) for (let c = 0; c < cfg.cols; c++) {
      const t = G.tiles[r][c];
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tile' + (t.empty ? ' empty' : '');
      btn.style.gridRow = r + 1; btn.style.gridColumn = c + 2;
      if (t.empty) { btn.disabled = true; btn.setAttribute('aria-hidden', 'true'); btn.tabIndex = -1; }
      else {
        btn.innerHTML = pipeSVG(t.mask);
        btn.setAttribute('aria-label', `Rotate pipe at row ${r + 1}, column ${c + 1}`);
        btn.addEventListener('click', () => rotateTile(r, c));
      }
      t.el = btn; t.svg = btn.querySelector('svg');
      board.appendChild(btn);
    }
    const ac = document.createElement('div');
    ac.className = 'term ac'; ac.dataset.cm = 'acTerm'; ac.style.gridRow = cfg.ac + 1; ac.style.gridColumn = cfg.cols + 2;
    ac.innerHTML = FLAKE + '<span>AC</span>';
    ac.setAttribute('aria-label', 'Air conditioner input');
    board.appendChild(ac);
    setSize();
  }

  function masks() { return G.tiles.map(row => row.map(t => t.mask)); }

  function updatePower() {
    const cfg = LEVELS[G.level];
    const res = flood(cfg, masks());
    G.tiles.flat().forEach(t => t.el.classList.toggle('powered', res.seen.has(t.r + ',' + t.c)));
    $('acTerm').classList.toggle('live', res.win);
    return res;
  }

  function nextMisaligned() {
    return G.tiles.flat().filter(t => t.pathIdx >= 0 && !fits(t.mask, t.target)).sort((a, b) => a.pathIdx - b.pathIdx)[0];
  }

  function updateGuide() {
    G.tiles.flat().forEach(t => t.el.classList.remove('guide'));
    if (G.level !== 0 || G.locked) return;
    const t = nextMisaligned();
    if (t) t.el.classList.add('guide');
  }

  function updateHUD() {
    const dots = $('dots'); dots.innerHTML = '';
    LEVELS.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'dot' + (G.scores[i] ? ' done' : i === G.level ? ' current' : '');
      dots.appendChild(d);
    });
    $('hudLevel').innerHTML = `${G.level + 1}<small>/3</small>`;
    $('hudClicks').innerHTML = `${G.clicks}<small>/${G.limit}</small>`;
    const pct = G.limit ? (G.clicks / G.limit) * 100 : 0;
    const bar = $('hudBar'); bar.style.width = pct + '%'; bar.classList.toggle('low', pct <= 25);
    $('hudBonus').textContent = '+' + G.clicks * BONUS_PER_CLICK;
    $('hudTotal').textContent = totalScore();
    const disable = G.busy;
    $('btnRestart').disabled = disable;
    $('btnHint').disabled = disable || G.locked;
    $('btnFinish').disabled = disable;
  }

  function updateAll() { updatePower(); updateGuide(); updateHUD(); }

  function totalScore() { return G.scores.reduce((s, x) => s + (x ? x.total : 0), 0); }
  function levelsDone() { return G.scores.filter(Boolean).length; }

  function rotateTile(r, c) {
    if (G.locked || G.busy || G.clicks <= 0) return;
    const t = G.tiles[r][c];
    if (t.empty) return;
    t.mask = rot1(t.mask);
    t.deg += 90;
    t.svg.style.transform = `rotate(${t.deg}deg)`;
    G.clicks--;
    if (t.el.classList.contains('hint')) clearHint();
    const res = updatePower();
    updateGuide(); updateHUD();
    if (res.win) return onWin(res);
    if (G.level === 0) {
      const pathPowered = G.tiles.flat().filter(x => x.pathIdx >= 0 && res.seen.has(x.r + ',' + x.c)).length;
      if (pathPowered > G.maxPowered && pathPowered > 1) setCoach('Nice! <b>Cyan pipes</b> are carrying power. Keep rotating toward the AC →');
      else if (pathPowered < G.maxPowered) setCoach('Oops — that broke the link. Keep tapping: <b>four taps</b> bring a pipe back to where it started.');
      G.maxPowered = Math.max(G.maxPowered, pathPowered);
    }
    if (G.clicks === 0) {
      G.locked = true; G.failed = true; updateHUD();
      setTimeout(showFail, 450);
    }
  }

  function clearHint() {
    clearTimeout(G.hintTimer);
    G.tiles.flat().forEach(t => t.el && t.el.classList.remove('hint'));
  }

  function showHint() {
    if (G.locked || G.busy) return;
    const cfg = LEVELS[G.level];
    const t = nextMisaligned();
    if (!t) { setCoach('Every pipe on the main route is aligned — check the source and AC ends.'); return; }
    clearHint();
    const k = minTurns(t.mask, t.target);
    t.el.dataset.taps = `TAP ×${k}`;
    t.el.classList.add('hint');
    if (cfg.hintCost) G.hints++;
    setCoach(`<b>Hint:</b> rotate the highlighted tile <b>${k} time${k > 1 ? 's' : ''}</b>.` + (cfg.hintCost ? ` (−${cfg.hintCost} pts)` : ' Hints are free in the tutorial.'));
    G.hintTimer = setTimeout(clearHint, 4000);
    updateHUD();
  }

  function computeScore() {
    const cfg = LEVELS[G.level];
    const bonus = G.clicks * BONUS_PER_CLICK;
    const penalty = G.hints * cfg.hintCost;
    const total = Math.max(Math.round(cfg.base / 2), cfg.base + bonus - penalty);
    return { level: G.level + 1, base: cfg.base, bonus, penalty, unused: G.clicks, total };
  }

  function onWin(res) {
    G.locked = true; G.busy = true;
    clearHint();
    board.classList.add('complete');
    G.tiles.flat().forEach(t => { if (res.seen.has(t.r + ',' + t.c)) t.el.classList.add('complete'); });
    G.scores[G.level] = computeScore();
    updateGuide(); updateHUD();
    setCoach('<b>Circuit complete!</b> Power is flowing — the TURBRO AC is starting up.');
    startAC(() => { G.busy = false; updateHUD(); showLevelComplete(); });
  }

  function lerpColor(a, b, t) {
    const pa = a.match(/\w\w/g).map(h => parseInt(h, 16)), pb = b.match(/\w\w/g).map(h => parseInt(h, 16));
    return 'rgb(' + pa.map((v, i) => Math.round(v + (pb[i] - v) * t)).join(',') + ')';
  }

  function setTemp(v, on) {
    $('roomTemp').textContent = v + '°F';
    $('roomTemp').style.color = lerpColor('ff5a4f', '22e1ff', (START_TEMP - v) / (START_TEMP - END_TEMP));
    $('acLcd').textContent = on ? v + '°F' : '--°F';
  }

  function resetAC() {
    cancelAnimationFrame(G.tempRaf);
    $('acPanel').classList.remove('on');
    $('acStatus').textContent = 'Standby · No power';
    setTemp(START_TEMP, false);
  }

  function startAC(done) {
    const panel = $('acPanel');
    panel.classList.add('on');
    $('acStatus').textContent = 'Power on · Cooling…';
    setTemp(START_TEMP, true);
    const delay = 500, dur = 2300; let t0 = null;
    const step = ts => {
      if (t0 === null) t0 = ts;
      const p = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
      const eased = 1 - Math.pow(1 - p, 3);
      setTemp(Math.round(START_TEMP - (START_TEMP - END_TEMP) * eased), true);
      if (p < 1) G.tempRaf = requestAnimationFrame(step);
      else { $('acStatus').textContent = `Target ${END_TEMP}°F reached`; setTimeout(done, 450); }
    };
    G.tempRaf = requestAnimationFrame(step);
  }

  function openModal(html, win) {
    const m = $('modal');
    m.className = 'modal' + (win ? ' win' : '');
    m.innerHTML = html;
    $('modalOverlay').classList.add('show');
    const first = m.querySelector('button'); if (first) first.focus();
  }
  function closeModal() { $('modalOverlay').classList.remove('show'); }

  function showLevelComplete() {
    const s = G.scores[G.level];
    const last = G.level === LEVELS.length - 1;
    openModal(`
      <div class="eyebrow">Level ${s.level} complete</div>
      <h2 id="${$('modalOverlay').getAttribute('aria-labelledby')}">Room cooled to ${END_TEMP}°F</h2>
      <p>${last ? 'You powered every circuit. Master electrician status unlocked.' : 'Nice wiring. The next grid is longer and more complex.'}</p>
      <div class="rows">
        <div class="row"><span>Circuit completed</span><b>+${s.base}</b></div>
        <div class="row"><span>Unused clicks (${s.unused} × ${BONUS_PER_CLICK})</span><b>+${s.bonus}</b></div>
        ${s.penalty ? `<div class="row"><span>Hints used</span><b class="neg">−${s.penalty}</b></div>` : ''}
        <div class="row"><span>Level score</span><b>${s.total}</b></div>
        <div class="row total"><span>Total score</span><b>${totalScore()}</b></div>
      </div>
      <div class="actions">
        <button class="btn ${last ? 'btn-amber' : 'btn-primary'}" type="button" data-cm="mNext">${last ? 'See Results & Coupon' : 'Next Level →'}</button>
        ${last ? '' : '<button class="btn" type="button" data-cm="mFinish">Finish & Share Score</button>'}
      </div>`, true);
    $('mNext').onclick = () => { closeModal(); if (last) showResults(); else startLevel(G.level + 1, true); };
    if (!last) $('mFinish').onclick = () => { closeModal(); showResults(); };
  }

  function showFail() {
    openModal(`
      <div class="eyebrow">Out of clicks</div>
      <h2 id="${$('modalOverlay').getAttribute('aria-labelledby')}">Circuit not complete</h2>
      <p>The AC never got power and the room is still ${START_TEMP}°F. Retry this level with the same layout, or bank your score so far.</p>
      <div class="rows">
        <div class="row"><span>Levels completed</span><b>${levelsDone()} / 3</b></div>
        <div class="row total"><span>Total score</span><b>${totalScore()}</b></div>
      </div>
      <div class="actions">
        <button class="btn btn-primary" type="button" data-cm="mRetry">Retry Level ${G.level + 1}</button>
        <button class="btn" type="button" data-cm="mFinish">Finish & Share Score</button>
      </div>`, false);
    $('mRetry').onclick = () => { closeModal(); startLevel(G.level, false); };
    $('mFinish').onclick = () => { closeModal(); showResults(); };
  }

  /* ---------- Results ---------- */
  function showResults() {
    if (!G.coupon) G.coupon = COUPONS[rand(COUPONS.length)];
    const total = totalScore(), done = levelsDone();
    const bonus = G.scores.reduce((s, x) => s + (x ? x.bonus : 0), 0);
    $('resScore').textContent = total;
    $('resLevels').textContent = `${done} / 3`;
    $('resBonus').textContent = '+' + bonus;
    $('resGrid').innerHTML = LEVELS.map((cfg, i) => {
      const s = G.scores[i];
      return `<div class="lv ${s ? 'done' : ''}"><div class="lbl">Level ${i + 1}</div><div class="val">${s ? s.total : '—'}</div><div class="lbl" style="margin-top:2px">${s ? cfg.name : 'Not cleared'}</div></div>`;
    }).join('');
    $('couponCode').textContent = G.coupon;
    $('btnCopy').textContent = 'COPY'; $('btnCopy').classList.remove('ok');
    $('copyNote').textContent = 'Use this code at checkout on TURBRO.';
    $('btnResume').hidden = done === LEVELS.length;
    $('resultsOverlay').classList.add('show');
    $('resultsOverlay').scrollTop = 0;
    $('dlNote').textContent = '1080 × 1350 PNG — sized for Instagram posts.';
    buildCard();
  }

  async function copyCoupon() {
    const code = G.coupon;
    let ok = false;
    try { if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(code); ok = true; } } catch (e) {}
    if (!ok) {
      const ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, code.length);
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
    }
    const b = $('btnCopy');
    if (ok) { b.textContent = 'COPIED!'; b.classList.add('ok'); $('copyNote').textContent = `“${code}” copied to your clipboard.`; }
    else { $('copyNote').textContent = 'Copy blocked by your browser — long-press the code to copy it.'; }
    setTimeout(() => { b.textContent = 'COPY'; b.classList.remove('ok'); }, 2200);
  }

  /* ---------- Score card (1080 × 1350) ---------- */
  async function ensureFonts() {
    try {
      await Promise.race([
        Promise.all(['600', '700', '800'].map(w => document.fonts.load(`${w} 40px Manrope`))),
        new Promise(r => setTimeout(r, 2500))
      ]);
    } catch (e) {}
  }
  function rr(x, X, Y, w, h, r) {
    x.beginPath(); x.moveTo(X + r, Y); x.arcTo(X + w, Y, X + w, Y + h, r); x.arcTo(X + w, Y + h, X, Y + h, r);
    x.arcTo(X, Y + h, X, Y, r); x.arcTo(X, Y, X + w, Y, r); x.closePath();
  }
  function spaced(x, text, X, Y, sp, align) {
    const chars = [...text];
    const total = chars.reduce((s, ch) => s + x.measureText(ch).width, 0) + sp * (chars.length - 1);
    let cx = align === 'right' ? X - total : align === 'center' ? X - total / 2 : X;
    const prev = x.textAlign; x.textAlign = 'left';
    for (const ch of chars) { x.fillText(ch, cx, Y); cx += x.measureText(ch).width + sp; }
    x.textAlign = prev;
  }

  function drawCard() {
    const cv = document.createElement('canvas'); cv.width = 1080; cv.height = 1350;
    const x = cv.getContext('2d');
    const F = (w, s) => `${w} ${s}px Manrope, system-ui, sans-serif`;
    const total = totalScore(), done = levelsDone();

    x.fillStyle = '#0b0d10'; x.fillRect(0, 0, 1080, 1350);
    x.strokeStyle = 'rgba(255,255,255,0.035)'; x.lineWidth = 1;
    for (let i = 0; i <= 1080; i += 54) { x.beginPath(); x.moveTo(i + .5, 0); x.lineTo(i + .5, 1350); x.stroke(); }
    for (let j = 0; j <= 1350; j += 54) { x.beginPath(); x.moveTo(0, j + .5); x.lineTo(1080, j + .5); x.stroke(); }
    let g = x.createRadialGradient(960, 160, 0, 960, 160, 560);
    g.addColorStop(0, 'rgba(214,0,15,0.30)'); g.addColorStop(1, 'rgba(214,0,15,0)');
    x.fillStyle = g; x.fillRect(0, 0, 1080, 1350);
    g = x.createRadialGradient(200, 600, 0, 200, 600, 520);
    g.addColorStop(0, 'rgba(255,176,32,0.10)'); g.addColorStop(1, 'rgba(255,176,32,0)');
    x.fillStyle = g; x.fillRect(0, 0, 1080, 1350);
    x.fillStyle = '#d6000f'; x.fillRect(0, 0, 1080, 14);

    rr(x, 60, 58, 236, 62, 4); x.fillStyle = '#d6000f'; x.fill();
    x.fillStyle = '#ffffff'; x.font = F(800, 36); x.textBaseline = 'middle';
    spaced(x, 'TURBRO', 178, 90, 8, 'center');
    x.textBaseline = 'alphabetic';
    x.fillStyle = '#8a929c'; x.font = F(800, 30); spaced(x, 'SCORE CARD', 1020, 100, 6, 'right');

    x.font = F(800, 124); x.fillStyle = '#eef1f4'; x.fillText('CIRCUIT', 54, 262);
    x.fillStyle = '#d6000f'; x.fillText('MASTER', 54, 382);

    rr(x, 60, 420, 960, 300, 4); x.fillStyle = '#13171c'; x.fill(); x.strokeStyle = '#2a3038'; x.lineWidth = 2; x.stroke();
    rr(x, 60, 420, 8, 300, 4); x.fillStyle = '#ffb020'; x.fill();
    x.fillStyle = '#8a929c'; x.font = F(800, 32); spaced(x, 'TOTAL SCORE', 104, 484, 5, 'left');
    x.font = F(800, 176); x.fillStyle = '#ffb020'; x.shadowColor = 'rgba(255,176,32,0.55)'; x.shadowBlur = 40;
    x.fillText(String(total), 96, 668); x.shadowBlur = 0;
    x.fillStyle = '#8a929c'; x.font = F(800, 32); spaced(x, 'LEVELS CLEARED', 976, 484, 5, 'right');
    x.font = F(800, 108); x.fillStyle = '#eef1f4'; x.textAlign = 'right'; x.fillText(`${done}/3`, 976, 612); x.textAlign = 'left';
    for (let i = 0; i < 3; i++) { rr(x, 746 + i * 80, 642, 70, 22, 3); x.fillStyle = G.scores[i] ? '#ffb020' : '#2a3038'; x.fill(); }

    LEVELS.forEach((cfg, i) => {
      const bx = 60 + i * 330, s = G.scores[i];
      rr(x, bx, 750, 300, 130, 4); x.fillStyle = '#13171c'; x.fill(); x.strokeStyle = '#2a3038'; x.lineWidth = 2; x.stroke();
      x.fillStyle = s ? '#ffb020' : '#343c47'; x.fillRect(bx + 2, 752, 296, 5);
      x.fillStyle = '#8a929c'; x.font = F(800, 27); spaced(x, `LEVEL ${i + 1}`, bx + 28, 800, 4, 'left');
      x.font = F(800, 54); x.fillStyle = s ? '#eef1f4' : '#4a5360'; x.fillText(s ? String(s.total) : '—', bx + 28, 856);
    });

    rr(x, 60, 912, 960, 180, 4); x.fillStyle = 'rgba(214,0,15,0.08)'; x.fill();
    x.setLineDash([18, 10]); x.strokeStyle = '#d6000f'; x.lineWidth = 3; x.stroke(); x.setLineDash([]);
    x.fillStyle = '#ff4d57'; x.font = F(800, 30); spaced(x, 'POWER UP · COOL DOWN', 540, 966, 6, 'center');
    x.fillStyle = '#ffffff'; x.font = F(800, 64); spaced(x, 'PLAY & UNLOCK A REWARD', 540, 1048, 4, 'center');

    const pts = [[130,1170],[330,1170],[330,1218],[600,1218],[600,1142],[800,1142],[800,1170],[950,1170]];
    const line = () => { x.beginPath(); x.moveTo(pts[0][0], pts[0][1]); pts.slice(1).forEach(p => x.lineTo(p[0], p[1])); };
    x.lineJoin = 'round'; x.lineCap = 'butt';
    line(); x.strokeStyle = '#2b3139'; x.lineWidth = 30; x.stroke();
    line(); x.strokeStyle = done === 3 ? '#ffb020' : done ? '#22e1ff' : '#d6000f'; x.lineWidth = 10;
    x.shadowColor = x.strokeStyle; x.shadowBlur = 26; x.stroke(); x.shadowBlur = 0;
    rr(x, 60, 1135, 70, 70, 4); x.fillStyle = '#d6000f'; x.fill();
    x.save(); x.translate(71, 1146); x.scale(2, 2); x.fillStyle = '#fff'; x.fill(new Path2D('M13 2 4 14h7l-1 8 9-12h-7l1-8z')); x.restore();
    rr(x, 950, 1135, 70, 70, 4); x.fillStyle = done === 3 ? '#ffb020' : '#1a1f26'; x.fill();
    x.save(); x.translate(961, 1146); x.scale(2, 2); x.strokeStyle = done === 3 ? '#14100a' : '#8a929c'; x.lineWidth = 2.4; x.lineCap = 'round';
    x.stroke(new Path2D('M12 2v20M3.4 7l17.2 10M3.4 17 20.6 7')); x.restore();

    x.fillStyle = '#c3c9d1'; x.font = F(700, 36); x.textAlign = 'center';
    x.fillText(done === 3 ? `Room cooled from ${START_TEMP}°F to ${END_TEMP}°F. Can you beat my score?` : 'Can you beat my score?', 540, 1286);
    x.textAlign = 'left';
    x.fillStyle = '#d6000f'; x.font = F(800, 30); spaced(x, '#TURBRO   #CIRCUITMASTER', 540, 1326, 4, 'center');
    return cv;
  }

  async function buildCard() {
    const pv = $('preview');
    pv.innerHTML = '<span>Generating score card…</span>';
    await ensureFonts();
    G.cardCanvas = drawCard();
    const img = new Image();
    img.alt = `Circuit Master score card: ${totalScore()} points, ${levelsDone()} of 3 levels completed`;
    img.src = G.cardCanvas.toDataURL('image/png');
    pv.innerHTML = ''; pv.appendChild(img);
    setupShare();
  }

  function cardBlob() {
    return new Promise(res => {
      if (!G.cardCanvas) return res(null);
      if (G.cardCanvas.toBlob) G.cardCanvas.toBlob(b => res(b), 'image/png'); else res(null);
    });
  }
  const fileName = () => `turbro-circuit-master-${totalScore()}.png`;

  async function downloadCard() {
    if (!G.cardCanvas) { await buildCard(); }
    const blob = await cardBlob();
    const a = document.createElement('a');
    let url;
    if (blob) url = URL.createObjectURL(blob); else url = G.cardCanvas.toDataURL('image/png');
    a.href = url; a.download = fileName(); a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    if (blob) setTimeout(() => URL.revokeObjectURL(url), 4000);
    $('dlNote').textContent = 'Score card downloaded. If nothing saved, long-press (or right-click) the preview image to save it.';
  }

  async function setupShare() {
    const btn = $('btnShare');
    btn.hidden = true;
    if (!navigator.share || !navigator.canShare) return;
    const blob = await cardBlob(); if (!blob) return;
    const file = new File([blob], fileName(), { type: 'image/png' });
    if (!navigator.canShare({ files: [file] })) return;
    btn.hidden = false;
    btn.onclick = async () => {
      try { await navigator.share({ files: [file], title: 'Circuit Master by TURBRO', text: `I scored ${totalScore()} in TURBRO Circuit Master!` }); } catch (e) {}
    };
  }

  /* ---------- Wiring ---------- */
  $('btnStart').onclick = () => { $('introOverlay').classList.remove('show'); };
  $('btnRestart').onclick = () => { closeModal(); startLevel(G.level, false); setCoach(`Level ${G.level + 1} restarted with the same layout. Clicks refilled.`); };
  $('btnHint').onclick = showHint;
  $('btnFinish').onclick = () => { if (!G.busy) showResults(); };
  $('btnCopy').onclick = copyCoupon;
  $('btnDownload').onclick = downloadCard;
  $('btnResume').onclick = () => {
    $('resultsOverlay').classList.remove('show');
    if (G.failed) startLevel(G.level, false);
  };
  $('btnPlayAgain').onclick = () => {
    $('resultsOverlay').classList.remove('show');
    G.scores = []; G.coupon = null; G.layouts = []; G.cardCanvas = null;
    startLevel(0, true);
  };
  let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(setSize, 80); });
  document.addEventListener('keydown', e => {
    if (game.hidden || e.key !== 'Escape') return;
    if ($('resultsOverlay').classList.contains('show') && !$('btnResume').hidden) {
      $('btnResume').click();
      return;
    }
    if ($('modalOverlay').classList.contains('show')) {
      closeModal();
      return;
    }
    closeGame();
  });
  game._setSize = setSize;

  startLevel(0, true);
    }

    playBtn.addEventListener('click', openGame);
    if (closeBtn) closeBtn.addEventListener('click', closeGame);

    // 链接带 ?part=circuit-master 时，先滚到本模块再开游戏。
    // 立刻 openGame 会锁住 body 滚动，所以等滚动停稳再弹。
    var part = new URLSearchParams(window.location.search).get('part');
    if (part && part === root.getAttribute('data-jump-id')) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      var top = root.getBoundingClientRect().top + window.pageYOffset - header - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(openGame, reduceMotion ? 0 : 700);
    }
  });
});
